import { z } from "zod";
import { ZDrofusInterfaceChangeEvent } from "./drofusInterfaceChangeEvent.schema";
export const ZDrofusChangeEventPnsFilterInput = z.array(z.string().min(1)).max(100).optional();
// Query-only constraints live here; event fields reuse the stored event contract.
export const ZChangeEventFiltersInput = ZDrofusInterfaceChangeEvent.pick({
    projectNo: true,
}).extend({
    includeSynchronizationChanges: z.boolean().default(false),
    search: z.string().max(120).optional(),
    pns: ZDrofusChangeEventPnsFilterInput,
    roomFunctionNo: ZDrofusInterfaceChangeEvent.shape.context.removeDefault().shape.room
        .unwrap().shape.functionNo,
    roomFunctionNumbers: z.array(z.string().min(1)).max(2000).optional(),
    dateFrom: z.string().min(1).optional(),
    dateTo: z.string().min(1).optional(),
    changeTypes: ZDrofusInterfaceChangeEvent.shape.changeType.array().max(3).optional(),
    affectedDisciplines: ZDrofusInterfaceChangeEvent.shape.affectedDisciplines
        .removeDefault().max(10).optional(),
    attributeKeys: ZDrofusInterfaceChangeEvent.shape.changeKey.array().max(200).optional(),
    mmiCodes: z.array(z.string().min(1)).max(50).optional(),
    statuses: ZDrofusInterfaceChangeEvent.shape.status.removeDefault().array().max(3).optional(),
    severities: ZDrofusInterfaceChangeEvent.shape.severity.array().max(3).optional(),
});
export const ZChangeEventAttributeOption = ZDrofusInterfaceChangeEvent.pick({
    displayName: true,
}).extend({
    displayName: ZDrofusInterfaceChangeEvent.shape.displayName.nullable(),
    key: ZDrofusInterfaceChangeEvent.shape.changeKey,
    count: z.number().int().positive(),
});
export const ZChangeEventAttributeOptionsResponse = z.object({
    items: ZChangeEventAttributeOption.array(),
});
